// extracted by mini-css-extract-plugin
export default {"storage":"Storage_storage__s-Kpx"};